module.exports = __webpack_public_path__ + "img/o-file.19b3ed4a.png";